export const ApplicantFormControlConstants = {
  firstName: 'firstName',
  middleInitial: 'middleInitial',
  lastName: 'lastName',
  nameSuffix: 'nameSuffix',
  dateOfBirth: 'dateOfBirth'
};